import React, { useRef } from "react";
import Breadcrumb from "../../utils/Breadcrumb";
import BackButton from "../../utils/Button";
import { TableLoader } from "../Loader";
import NuDateFormat from "../../utils/NuDate";
import { PaperClip } from "../../assets/icons";
import { useReactToPrint } from "react-to-print";

function ViewPreDefinedIndex({
  standardName = "",
  menu = "",
  label = "",
  header = [],
  isLoading = false,
  hasFilter = false,
  removeFilter = () => {},
  setShowFilter = () => {},
  pdfUrl = "",
  downloadFileName = "",
  dataView = [],
  startDate="",
  endDate="",
  review=""
}) {
  const contentRef = useRef(null);

  const reactToPrintFn = useReactToPrint({
    contentRef: contentRef,
    documentTitle: downloadFileName || "report",
    pageStyle: `
    @page {
      size: landscape;
      margin-left: 1mm;
      margin-right: 1mm;
      margin-top: 0;
      margin-bottom: 15mm;
      padding-bottom:10mm;
    }
    @media print {
      body {
            -webkit-print-color-adjust: exact;
            print-color-adjust: exact;
            font-family: Arial, sans-serif;
            counter-reset: page;
            }
    }
    `,
  });

  return (
    <div className="w-full h-full mx-auto">
      <div className="w-[93%] flex justify-between items-center gap-x-6 py-1 px-3 mx-auto">
        <Breadcrumb
          items={[
            {
              name: "Standard",
              link: "/main/standard",
            },
            {
              name: standardName,
            },
            {
              name: menu,
            },
            {
              name: "Pre-Defined Reports",
            },
            {
              name: label,
            },
          ]}
        />
        <BackButton />
      </div>
      <div className="w-[96%] mx-auto h-[calc(100vh-113px)] py-2 bg-white shadow-[0_8px_30px_rgb(0,0,0,0.12)] rounded-2xl overflow-y-auto">
        <div className=" h-8 flex justify-between items-center w-full px-4">
          <p className="text-xs 2xl:text-sm text-text">{label}</p>

          <div style={{ display: "none" }}>
            <div ref={contentRef}>
              <PrintData
                data={dataView}
                company={"company"}
                standardname={standardName}
                review={review}
                startDate={startDate}
                endDate={endDate}
                status={"status"}
                header={header}
              />
            </div>
          </div>

          <div className=" flex gap-3 justify-center items-center">
            <button
              className=" px-3 text-xs 2xl:text-sm bg-primary text-white rounded-md "
              onClick={setShowFilter}
            >
              Filter
            </button>
            {hasFilter &&
            
            <button
            className=" px-3 text-xs 2xl:text-sm  bg-primary text-white rounded-md "
            onClick={removeFilter}
          >
            Clear filter
          </button>}
            <div onClick={reactToPrintFn} className=" cursor-pointer">
              <svg
                fill="#7030a0"
                viewBox="0 0 16 16"
                height="22px"
                width="22px"
                //   {...props}
              >
                <path d="M2.5 8a.5.5 0 100-1 .5.5 0 000 1z" />
                <path d="M5 1a2 2 0 00-2 2v2H2a2 2 0 00-2 2v3a2 2 0 002 2h1v1a2 2 0 002 2h6a2 2 0 002-2v-1h1a2 2 0 002-2V7a2 2 0 00-2-2h-1V3a2 2 0 00-2-2H5zM4 3a1 1 0 011-1h6a1 1 0 011 1v2H4V3zm1 5a2 2 0 00-2 2v1H2a1 1 0 01-1-1V7a1 1 0 011-1h12a1 1 0 011 1v3a1 1 0 01-1 1h-1v-1a2 2 0 00-2-2H5zm7 2v3a1 1 0 01-1 1H5a1 1 0 01-1-1v-3a1 1 0 011-1h6a1 1 0 011 1z" />
              </svg>
            </div>
            {pdfUrl && (
              <a
                href={URL.createObjectURL(pdfUrl)}
                download={downloadFileName}
              >
                <svg
                  fill="#7030a0"
                  viewBox="0 0 16 16"
                  height="22px"
                  width="22px"
                  //   {...props}
                >
                  <path
                    fillRule="evenodd"
                    d="M14 4.5V14a2 2 0 01-2 2h-1v-1h1a1 1 0 001-1V4.5h-2A1.5 1.5 0 019.5 3V1H4a1 1 0 00-1 1v9H2V2a2 2 0 012-2h5.5L14 4.5zM1.6 11.85H0v3.999h.791v-1.342h.803c.287 0 .531-.057.732-.173.203-.117.358-.275.463-.474a1.42 1.42 0 00.161-.677c0-.25-.053-.476-.158-.677a1.176 1.176 0 00-.46-.477c-.2-.12-.443-.179-.732-.179zm.545 1.333a.795.795 0 01-.085.38.574.574 0 01-.238.241.794.794 0 01-.375.082H.788V12.48h.66c.218 0 .389.06.512.181.123.122.185.296.185.522zm1.217-1.333v3.999h1.46c.401 0 .734-.08.998-.237a1.45 1.45 0 00.595-.689c.13-.3.196-.662.196-1.084 0-.42-.065-.778-.196-1.075a1.426 1.426 0 00-.589-.68c-.264-.156-.599-.234-1.005-.234H3.362zm.791.645h.563c.248 0 .45.05.609.152a.89.89 0 01.354.454c.079.201.118.452.118.753a2.3 2.3 0 01-.068.592 1.14 1.14 0 01-.196.422.8.8 0 01-.334.252 1.298 1.298 0 01-.483.082h-.563v-2.707zm3.743 1.763v1.591h-.79V11.85h2.548v.653H7.896v1.117h1.606v.638H7.896z"
                  />
                </svg>
              </a>
            )}
          </div>
        </div>

        <div className=" w-full h-[calc(100vh-165px)]  relative overflow-y-auto">
          <div className=" sticky top-0 z-10">
            <table className="table-auto w-full">
              <thead className="bg-tabletitle">
                <tr className="flex items-center text-xs 2xl:text-sm ">
                  {header?.map((header) => (
                    <th
                      className={`text-center font-medium px-2  py-4 ${header.width}`}
                    >
                      {header?.headone}
                    </th>
                  ))}
                </tr>
              </thead>
            </table>
          </div>
          <div>
            <table className="table-auto w-full">
              {isLoading == true ? (
                <>
                  {[...Array(9)].map((_, index) => {
                    return <TableLoader key={index} header={header} />;
                  })}
                </>
              ) : (
                <tbody className="divide-y divide-gray-200">
                  {dataView.length > 0 ?
                    dataView?.map((item, index) => (
                      <tr
                        className="odd:bg-tableodd even:bg-tableeven text-xs 2xl:text-sm "
                        key={index}
                      >
                        {header?.map((headerItem) => (
                          <td
                            key={headerItem.fieldname}
                            className={`py-4  ${headerItem?.rowAlign||"text-center"} ${headerItem.width} ${(headerItem.headone === "Status" || headerItem.headone ==="Status Update")&& "capitalize"}`}
                          >
                            {headerItem.type === "file" &&
                            item[headerItem.fieldname] ? (
                              <div className=" w-full flex justify-center items-center">
                                <PaperClip />
                              </div>
                            ) : headerItem.type === "date" &&
                              item[headerItem.fieldname] !== "None" ? (
                              NuDateFormat({
                                value: item[headerItem.fieldname]||item[headerItem.feildnametwo],
                                format: "DD-MMM-yyyy",
                              })||" "
                            ) : (
                              item[headerItem.fieldname]|| item[headerItem.feildnametwo] ||item[headerItem.feildnamethree]|| " "
                            )}
                          </td>
                        ))}
                      </tr>
                    )):
                    <div className=" w-full flex justify-center items-center mt-10 font-medium">No Data </div>
                  }
                </tbody>
              )}
            </table>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ViewPreDefinedIndex;

function PrintData({
  data,
  company,
  standardname,
  review,
  startDate,
  endDate,
  status,
  header,
}) {
  let CompletedTemp = Number(status?.completed?.percentage || 0);
  let CompletedFinal = CompletedTemp.toFixed(1);
  let InProgressTemp = Number(status?.in_progress?.percentage || 0);
  let InProgressFinal = InProgressTemp.toFixed(1);
  let YetToStartTemp = Number(status?.yet_to_start?.percentage || 0);
  let YetToStartFinal = YetToStartTemp.toFixed(1);
  return (
    <div className="w-[96%] mx-auto bg-white  my-6">
      <div className="py-2 pl-5 flex justify-between items-center w-full">
        <div className=" flex justify-start gap-2 items-center">
          {company?.companyLogo && (
            <div className=" w-12 h-auto ">
              <img src={company?.companyLogo} width="100%" alt="#" />
            </div>
          )}
          <div className=" text-sm font-medium">
            {company?.companyName || ""}
          </div>
        </div>
        <div className=" text-sm font-medium">
          {` Standard ${standardname} ` || ""}
        </div>
        <div className=" text-sm font-medium">Vendor Management Report</div>
        <div className=" text-[9px] font-medium px-1">
          <p>{`Yet To Start : ${YetToStartFinal} %`}</p>
          <p>{`In Progress : ${InProgressFinal} %`}</p>
          <p>{`Completed : ${CompletedFinal} %`}</p>
        </div>
      </div>
      <div className="table-wrp block">
        <table className="w-full">
          <thead className="w-full bg-tabletitle">
            <tr className="text-xs 2xl:text-sm">
              {header?.map((headerItem) => (
                <th
                  className={`text-center font-medium px-2 py-4 ${headerItem.width}`}
                  key={headerItem.fieldname}
                >
                  {headerItem.headone}
                </th>
              ))}
            </tr>
          </thead>
          <tbody className="divide-y divide-gray-200">
            {data &&
              data?.map((item, index) => (
                <tr
                  className="odd:bg-tableodd even:bg-tableeven text-xs 2xl:text-sm "
                  key={index}
                >
                  {header?.map((headerItem) => (
                    <td
                      key={headerItem.fieldname}
                      className={`py-4 text-center ${headerItem.width} ${(headerItem.headone == "Status" || headerItem.headone =="Status Update") && "capitalize"}`}
                    >
                      {headerItem.fieldname === "attachment" &&
                      item[headerItem.fieldname] ? (
                        <PaperClip />
                      ) : headerItem.fieldname === "on_board_date" &&
                        item[headerItem.fieldname] !== "None" ? (
                        NuDateFormat({
                          value: item[headerItem.fieldname],
                          format: "DD-MMM-yyyy",
                        })
                      ) : (
                        item[headerItem.fieldname] || "-"
                      )}
                    </td>
                  ))}
                </tr>
              ))}
          </tbody>
          <tfoot className="h-8 fixed -bottom-3 w-[96%]">
            <tr className="w-full block px-4">
              <td colspan="8" className="w-full block">
                <div className="text-gray-600 flex justify-between items-end w-full">
                  <div>
                    <p className="text-[11px] my-0 leading-[10px]">
                      Certification Calendar Tracker
                    </p>
                    <p className="text-[11px] my-0 leading-[10px]">
                      {`${
                        startDate &&
                        startDate !== "None" &&
                        startDate !== "" &&
                        startDate !== null
                          ? NuDateFormat({
                              value: startDate,
                              format: "DD-MMM-YYYY",
                            })
                          : ""
                      } ${
                        startDate &&
                        startDate !== "None" &&
                        startDate !== "" &&
                        startDate !== null
                          ? "/"
                          : ""
                      } ${
                        endDate &&
                        endDate !== "None" &&
                        endDate !== "" &&
                        endDate !== null
                          ? NuDateFormat({
                              value: endDate,
                              format: "DD-MMM-YYYY",
                            })
                          : ""
                      }`}
                    </p>
                  </div>
                  <div className="text-center text-[11px]">
                    {`${NuDateFormat({
                      value: Date(),
                      format: "DD-MMM-YYYY",
                    })}/ ${NuDateFormat({
                      value: Date(),
                      format: "hh:mm:ss a",
                    })}`}
                  </div>
                  <div>
                    <p className="text-[11px] my-0 leading-[10px]">
                      {review &&
                        review !== "" &&
                        review !== null &&
                        review !== "null" &&
                        "Reviewed and Approved"}
                    </p>
                  </div>
                </div>
              </td>
            </tr>
          </tfoot>
        </table>
      </div>
    </div>
  );
}
